import { CONTACT, EMAIL } from "@/data/site";
import { MaskedLines, Reveal } from "@/components/site/Motion";
import { UkClock } from "@/components/site/Clock";

export const Contact = () => (
  <section id="contact" data-testid="contact-section" aria-labelledby="contact-title" className="bg-ink px-6 pt-24 text-paper lg:px-12 lg:pt-36">
    <p className="label mb-10 text-paper/70">(03) Contact</p>
    <h2 id="contact-title" className="font-display text-[clamp(2.75rem,8.4vw,10rem)] font-medium leading-[0.92] tracking-[-0.055em]">
      <MaskedLines inView lines={CONTACT.headline} lineClass={(i) => (i === 1 ? "lg:pl-[10vw]" : "")} />
    </h2>
    <Reveal className="mt-16 grid grid-cols-1 gap-10 border-t border-paper/20 pt-8 md:grid-cols-12 lg:mt-24">
      <div className="md:col-span-8">
        <p className="label mb-4 text-paper/70">Email</p>
        <a
          href={`mailto:${EMAIL}`}
          data-testid="contact-email-link"
          className="group inline-flex items-baseline gap-3 break-all font-display text-[clamp(1.6rem,4.2vw,4rem)] font-medium tracking-[-0.04em]"
        >
          <span className="u-link">{EMAIL}</span>
          <span className="inline-block transition-transform duration-500 group-hover:-translate-y-1 group-hover:translate-x-1" aria-hidden="true">↗</span>
        </a>
      </div>
      <div className="space-y-6 text-sm md:col-span-4">
        <div>
          <p className="label mb-2 text-paper/70">Location</p>
          <p data-testid="contact-location">{CONTACT.location}</p>
        </div>
        <div>
          <p className="label mb-2 text-paper/70">Local time</p>
          <UkClock />
        </div>
      </div>
    </Reveal>
  </section>
);
